import { Link } from "@tanstack/react-router";
import { useState } from "react";
import { NAV, SITE } from "@/lib/site";
import { SiteSearch } from "@/components/SiteSearch";

export function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 border-b border-border bg-background/95 backdrop-blur-xl">
      <div className="container-svg flex h-[72px] items-center justify-between gap-4">
        <Link to="/" className="group flex items-center gap-2.5" aria-label={`${SITE.name} — Início`}>
          <span aria-hidden className="inline-flex h-9 w-9 items-center justify-center rounded-md bg-foreground font-bold text-background text-sm leading-none tracking-tighter">CA</span>
          <span className="flex flex-col leading-none">
            <span className="font-display text-lg md:text-xl font-bold tracking-tight text-foreground">Concurso Astor</span>
            <span className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground mt-1">Empresas & negócios</span>
          </span>
        </Link>
        <nav className="hidden items-center gap-0.5 lg:flex" aria-label="Principal">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              activeOptions={n.to === "/" ? { exact: true } : undefined}
              activeProps={{ className: "text-primary-foreground bg-primary" }}
              inactiveProps={{ className: "text-foreground hover:bg-secondary" }}
              className="whitespace-nowrap rounded-md px-3 py-1.5 text-[13px] font-semibold leading-none transition-all"
            >
              {n.label}
            </Link>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <Link to="/blog" className="hidden md:inline-flex btn-accent px-4 py-2 text-xs">Ler artigos</Link>
          <button
            type="button"
            onClick={() => setOpen((o) => !o)}
            className="lg:hidden inline-flex h-11 w-11 items-center justify-center rounded-md border border-border bg-background text-foreground"
            aria-label="Abrir menu"
            aria-expanded={open}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
              {open ? <path d="M6 6l12 12M6 18L18 6" /> : <><path d="M4 7h16" /><path d="M4 12h16" /><path d="M4 17h16" /></>}
            </svg>
          </button>
        </div>
      </div>
      <div className="hidden md:block border-t border-border bg-secondary/40">
        <div className="container-svg py-2 flex justify-center">
          <div className="w-full max-w-2xl">
            <SiteSearch compact />
          </div>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-border bg-background">
          <nav className="container-svg flex flex-col py-3" aria-label="Menu mobile">
            <div className="mb-2"><SiteSearch compact /></div>
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                activeOptions={{ exact: n.to === "/" }}
                activeProps={{ className: "text-primary-foreground bg-primary" }}
                inactiveProps={{ className: "text-foreground hover:bg-secondary" }}
                className="rounded-md px-3 py-3 text-sm font-semibold transition-colors"
              >
                {n.label}
              </Link>
            ))}
            <Link to="/blog" onClick={() => setOpen(false)} className="btn-accent mt-3 w-full">Ler artigos</Link>
          </nav>
        </div>
      )}
    </header>
  );
}
